<template>
	<div>
		<h1>Projeler</h1>
		<div id="wrapper">
			<div v-for="(item, i) in items" :key="i" class="card">
				<h3>{{item.title}}</h3>
				<span class="tag">{{item.kind}}</span>
				<span class="tag">{{item.year}}</span>
				<span class="tag">{{item.place}}</span>
				<span class="tag">{{item.role}}</span>
				<span :class="item.completion?'tag complete':'tag incomplete'">{{item.completion?'Tamamlandı':'Tamamlanmadı'}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	const firebase = require('firebase/app');

	export default {
		name: 'Project',
		
		data() {
			return {
				items: [],
			}
		},

		created(){
			firebase.database().ref('/ProjectItem').once('value').then((snapshot) => {
				this.items = snapshot.val(); 
			});
		},
	}
</script>

<style lang="scss" scoped>
	h1{
		font-size: 1.2em;
	}

	h3{
		font-size: .8em;
	}

	h1, h3{
		text-align: center;
		text-shadow: 0 3px 5px #333333b9;
		color: #3a3a3a;
		transform: scale3d(1, 1, 1);
		transition: text-shadow 1s, transform 1s;
	}

	.tag{
		font-size: .6em;
		color: #333;
		background-color: #35ff68;
		margin-left: .4em;
		margin-right: .4em;
	}

	.complete{
		background-color: #009451;
		color: white;
		font-weight: bold;
	}

	.incomplete{
		background-color: #ff002b;
		color: white;
		font-weight: bold;
	}

	@media screen and (max-width: 1024px) {
		h1{
			font-size: 1em;
		}
		h3{
			font-size: .6em;
		}

		.tag{
			font-size: .4em;
		}
	}

	#wrapper{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		flex-flow: wrap;
		justify-content: space-between;
		align-items: flex-start;
		align-content: space-around;
	}

	.card{
		width: 80%;
		padding: 15px;
		margin: 20px auto;
		border-radius: 25px;
		background-color: white;
		box-shadow: 0 3px 5px #333333a9;
		transition: transform 1s;
		transform: scale3d(1, 1, 1);
	
		&:hover{
			transition: transform 1s;
			transform: scale3d(1.1, 1.1, 1.1);
			cursor: pointer;
		}
	}

	.image{
		width: 100%;
		border-radius: 20px;
	}
</style>